export const isBulkOrderCustomerTimerExpired = (startUtc?: string, duration?: number): boolean => {
  if (!startUtc || !duration) return false
  const expiresAt = new Date(addUtcTimezoneMarkToDateString(startUtc)).getTime() + duration * 1000
  return new Date().getTime() >= expiresAt
}

export const addUtcTimezoneMarkToDateString = (dateString?: string) : string => {
  if(!dateString) return ""
  return dateString + "Z"
}
